import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { colors } from 'ui/theme';
import { InlineEdit, InlineEditCharacterCount, InlineEditInput } from 'ui/workflows/flowchart';
import { Announcement } from 'ui/announcement';

export const FLOWCHART_Z_INDEXES = {
  CANVAS: 1,
  // Make sure that nodes are always below action bar
  TOOLBAR: 2,
  SIDEBAR: 2,
  WARNING: 2,
};

export const FlowChartChildWrapper = styled.div`
  position: absolute;
  display: flex;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  .tile-sidebar {
    z-index: ${FLOWCHART_Z_INDEXES.SIDEBAR};
    flex: 0 0 auto;
  }
  canvas {
    z-index: ${FLOWCHART_Z_INDEXES.CANVAS};
  }
`;

const DISTANCE_FROM_FLOWCHART_BOUNDARY = 9;

export const ToolbarFlexContainer = styled.div`
  position: relative;
  flex: 1 1 auto;
  align-self: flex-end;
  z-index: ${FLOWCHART_Z_INDEXES.TOOLBAR};
`;

export const ToolbarWrapper = styled.div`
  position: absolute;
  z-index: ${FLOWCHART_Z_INDEXES.TOOLBAR};
  width: calc(100% - ${pxToRem(DISTANCE_FROM_FLOWCHART_BOUNDARY * 2)});
  left: ${pxToRem(DISTANCE_FROM_FLOWCHART_BOUNDARY)};
  bottom: ${pxToRem(DISTANCE_FROM_FLOWCHART_BOUNDARY)};
`;

export const InlineEditStyled = styled(InlineEdit)`
  ${InlineEditInput} {
    outline-color: ${colors.mustard10};
  }
  ${InlineEditCharacterCount} {
    color: ${colors.mustard100};
  }
`;

export const NodesCountWarningBanner = styled(Announcement)<{ subWidth: number }>`
  z-index: ${FLOWCHART_Z_INDEXES.WARNING};
  min-height: ${pxToRem(45)};
  width: calc(100% - ${({ subWidth }) => `${pxToRem(subWidth)}`});
  position: absolute;
  color: ${colors.textSecondary};
  background-color: ${colors.grey15};
  text-align: center;
`;

export const NodesCountWarningContainer = styled.div`
  display: flex;
  gap: ${pxToRem(6)};
  align-items: center;
  height: 100%;
`;
